export enum TaskType {
    Unspecified = 0,
    Custom = 999
}